var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 15.2782H9.99967C13.333 15.2782 14.6663 13.9448 14.6663 10.6115V6.61149C14.6663 3.27816 13.333 1.94482 9.99967 1.94482H5.99967C2.66634 1.94482 1.33301 3.27816 1.33301 6.61149V10.6115C1.33301 13.9448 2.66634 15.2782 5.99967 15.2782Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16699 8.61128L7.05366 10.4979L10.8337 6.72461",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.10cabd35ac5d5ea9e163c5f11857bc2c.svg";
export { ForwardRef as ReactComponent };